import {textSystem} from "../../utils/Constant";
import CustomIconButton from "../../component/custom-icon-button/CustomIconButton";
import {formatDateToDDMMYYYY, } from "../../utils/FormatUtils";
import {PLAN_STATUS_NAME} from "../constants/buildPlans";
import {LIST_CRITERIA} from "../../criteria/constants/commons";

const BuildPlansColumns = (props: any) => {
  const {handleOpenPlanModal, handleOpenConfirmDialog} = props;
  return [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: "50px",
      },
      cellStyle: {
        width: "50px",
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any, index: number, stt: number) => <span>{stt}</span>,
    },
    {
      name: "Thao tác",
      field: "actions",
      headerStyle: {
        width: "100px",
        minWidth: "100px",
      },
      cellStyle: {
        ...textSystem,
      },
      render: (row: any) => (
        <div className="d-flex justify-content-center gap-3">
          <CustomIconButton
            variant="edit"
            onClick={() => handleOpenPlanModal(row)}
          >
            <i className="bi bi-pencil-square text-navy"></i>
          </CustomIconButton>
          <CustomIconButton
            variant="delete"
            onClick={() =>
              handleOpenConfirmDialog(
                "Bạn có chắc chắn muốn xóa không?",
                row,
                "delete"
              )
            }
          >
            <i className="bi bi-trash3-fill text-danger"></i>
          </CustomIconButton>
        </div>
      ),
    },
    {
      name: "Năm",
      field: "year",
      cellStyle: {
        textAlign: "center",
        minWidth: "100px",
        ...textSystem,
      },
      // render: (row: any) => row.status ? PLAN_STATUS_NAME[row.status] : "",
    },
    {
      name: "Bộ tiêu chí",
      field: "classId",
      cellStyle: {
        textAlign: "center",
        minWidth: "250px",
        ...textSystem,
      },
      render: (row: any) => row.classId
        ? Object.values(LIST_CRITERIA).find(item => item.value === row.classId)?.name
        : "",
    },
    {
      name: "Tên kế hoạch",
      field: "name",
      cellStyle: {
        minWidth: "500px",
        ...textSystem,
      },
    },
    {
      name: "Ngày tạo",
      field: "createdDate",
      headerStyle: {
        width: "200px",
        minWidth: "200px",
      },
      cellStyle: {
        textAlign: "center",
        ...textSystem,
      },
      render: (row: any) => row?.createdDate ? formatDateToDDMMYYYY(row?.createdDate) : "",
    },
  ];
};

export default BuildPlansColumns;